import { createSlice } from '@reduxjs/toolkit';

// Type
const initialState = {
  rgs: null,
  game: null,
};

const generalSlice = createSlice({
  name: 'general',
  initialState,
  reducers: {
    setRgs: (state, { payload }) => {
      state.rgs = payload;
    },
    setGame: (state, { payload }) => {
      state.game = payload;
    },
  },
  extraReducers: {},
});

export const { reducer: generalReducer } = generalSlice;
export const { setRgs, setGame } = generalSlice.actions;
